module.exports = __webpack_public_path__ + "static/img/qihangCompany.7f89171b.png";